import { Component, Input } from '@angular/core';
import { Datagrid, DatagridColumn } from '@zipari/shared-ds-util-datagrid';
import { getValue } from '../../../shared/utils/get-value';
import { FormattingService } from '../../../shared/services/formatting.service';

@Component({
  selector: 'datagrid-footer',
  templateUrl: './datagrid-footer.component.html',
  styleUrl: './datagrid-footer.component.scss',
})
export class DatagridFooterComponent {
  @Input() rows: object[];
  @Input() config: Datagrid;
  @Input() footerDetail: object;

  constructor(private formattingService: FormattingService) {}

  public getColumnWidth(column: DatagridColumn) {
    return column.width && this.rows.length > 0 && column.width;
  }

  public getFormattedValue(row: object, column: Partial<DatagridColumn>): any {
    const formattedValue = this.formattingService.restructureValueBasedOnFormat(
      getValue(row, column.prop),
      column,
    );

    return formattedValue === 0 ? '0' : formattedValue;
  }
}
